import{Component}from '@theme/component';class RTEFormatter extends Component{connectedCallback(){super.connectedCallback();this.querySelectorAll('table').forEach(this.#formatTable)}
#formatTable(table){const wrapper=document.createElement('div');wrapper.classList.add('rte-table-wrapper');const parent=table.parentNode;if(parent){parent.insertBefore(wrapper,table);wrapper.appendChild(table)}}}
if(!customElements.get('rte-formatter')){customElements.define('rte-formatter',RTEFormatter)}
(function(){
  function cleanWholesaleDiscountText(){
    if(!/\/pages\/wholesale\/?$/.test(window.location.pathname)) return;
    var scope=document.querySelector('.biz-page');
    if(!scope) return;

    scope.querySelectorAll('.biz-discount-sub').forEach(function(el){
      if(/\u6298/.test(el.textContent)) el.textContent='Single-item fulfillment';
    });

    scope.querySelectorAll('.discount-cell, .vip-discount').forEach(function(el){
      var cleaned=el.textContent
        .replace(/\s*\/\s*[0-9.]+\u6298/g,'')
        .replace(/[0-9.]+\s*\u6298/g,'')
        .replace(/\s+\/\s*$/,'')
        .trim();
      if(cleaned && cleaned!==el.textContent.trim()) el.textContent=cleaned;
    });
  }

  function run(){
    cleanWholesaleDiscountText();
    if(!document.body) return;
    var observer=new MutationObserver(cleanWholesaleDiscountText);
    observer.observe(document.body,{childList:true,subtree:true});
    window.setTimeout(function(){ observer.disconnect(); },10000);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',run,{once:true});
  }else{
    run();
  }
})();
